<template>
  <v-app class="pldc"
    style="max-width: 600px; background-color: #EEEEEE; margin: auto;"
    :class="{'d-flex': true, 'flex-column': true, on_desktop: $vuetify.breakpoint.smAndUp }"
  >
    <div class="d-flex flex-column">
      <div class="d-flex" style="position: relative">
        <img src="@/assets/wizard/wizard-header-Referra-1102x529.png" style="width: 100%">
        <div class="overlay">
          <slot name="title">Default title text.</slot>
        </div>
        <v-icon
          large color="#2BE929" class="restart-button" 
          @click="$router.replace({ name: 'link'})"
        >
          mdi-restart
        </v-icon>
      </div>

      <v-main class="flex-grow-1">
        <slot />
      </v-main>
    </div>
  </v-app>
</template>

<script>
export default {
  name: 'WizardLayout',

  data: () => ({
    timer: null,
  }),

  mounted() {
    let router = this.$router

    this.timer = setTimeout(() => {
      console.log('restart after 5 min. of inactivity')
      router.replace({ name: 'link' })
    }, 5 * 60 * 1000)
  },

  destroyed() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
}
</script>

<style scoped>
  html, body {
    height: 100%;
  }

  /* .v-application--wrap {
    min-height: 100vh !important;
    min-height: -webkit-fill-available !important;
  }
 */
  div.overlay {
    color: white;
    position: absolute;
    top: 52.5%;
    left: 50%;
    font-size: 40px;
    font-weight: bold;
    line-height: 1.05;
    transform: translate(-50%, -50%);
    text-align: center;
    width: 85%;
  }

  .restart-button {
    position: absolute !important;
    bottom: 10px;
    right: 0;
  }
</style>